<mat-toolbar class="custom-elevation-z2">
  @if (!closeBanner && showOpeningBanner$()) {

  <mat-toolbar-row class="banner"
    [ngClass]="{'success': status() === 'Offen', 'warn': status() === 'Schließt bald', 'error': status() === 'Geschlossen'}">
    <div class="info-banner">
      @if(status() === 'Unbekannt') {
      <mat-spinner class="spinner" diameter="20"></mat-spinner>
      }
      @else {
      <span class="custom-label-medium">{{statusText()}}</span>
      }
    </div>
    <div class="closeButton"><mat-icon class="material-icons-outlined" (click)="closeBanner = true">close</mat-icon>
    </div>
  </mat-toolbar-row>
  }

  @if (isSmallScreen$()) {
  <mat-toolbar-row class="costum-mat-surface-container-highest">
    <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      @for(group of navbarPages$(); track $index) {
        @for(page of group.pages; track $index) {
        <button mat-menu-item [routerLink]="page.url.startsWith('/') ? page.url : '/' + page.url">
          <span>{{ page.name }}</span>
        </button>
        }
      }

      <button mat-menu-item (click)="scrollService.navigateAndScrollTo('/', 'about-us')">
        <span>Über uns</span>
      </button>
      <button mat-menu-item (click)="scrollService.navigateAndScrollTo('/', 'contact')">
        <span>Kontakt</span>
      </button>
    </mat-menu>
    <span class="example-spacer"></span>
    @if(isUsingBrowser && !isAppInstalled) {
      @if(installMethod === 'auto'){<button mat-flat-button class="caps" (click)="installPWA()">App installieren</button>}
      @if(installMethod === 'unsupported'){<button mat-flat-button class="caps" (click)="showInstallDeniedMessage()">App installieren</button>}
      @if(installMethod === 'manual'){<button mat-flat-button class="caps" (click)="showManualInstallInstructions()">App installieren</button>}
    }
  </mat-toolbar-row>
  }

  @else {

  <mat-toolbar-row>

    @let logo = logoId();
    @if (logo.success) {
      <app-editable-image 
        [elemId]="logo.payload" 
        [imageReference]="imageReference"
        [fileTypes]="supportedFileTypes" 
        [maxWidth]="120" 
        [maxHeight]="120"
        [hasPriority]="true"
        [customClass]="'logo-custom-class-image'">
      </app-editable-image>
    }

    <button mat-button class="caps" [routerLink]="'/'">{{ storeName$() }}</button>
    <span class="example-spacer"></span>

    @for(group of navbarPages$(); track $index) {
    <ng-container>
      @if(group.group != 'Ungrouped') {
      <ng-container>
        <button mat-button class="caps" [matMenuTriggerFor]="menu">{{ group.group }}</button>
        <mat-menu #menu="matMenu">
          @for(page of group.pages; track $index) {
            <button mat-menu-item [routerLink]="page.url.startsWith('/') ? page.url : '/' + page.url">
            {{ page.name }}
          </button>
          }
        </mat-menu>

      </ng-container>
      } @else {
      @for(page of group.pages; track $index) {
      <button mat-button class="caps" [routerLink]="page.url.startsWith('/') ? page.url : '/' + page.url">
        {{ page.name }}
      </button>
      }
      }
    </ng-container>
    }
    <button mat-button class="caps" (click)="scrollService.navigateAndScrollTo('/', 'about-us')">Über uns</button>
    <button mat-button class="caps" (click)="scrollService.navigateAndScrollTo('/', 'contact')">Kontakt</button>
    @if(isUsingBrowser && !isAppInstalled) {
      @if(installMethod === 'auto'){<button mat-flat-button class="caps" (click)="installPWA()">App installieren</button>}
      @if(installMethod === 'unsupported'){<button mat-flat-button class="caps" (click)="showInstallDeniedMessage()">App installieren</button>}
      @if(installMethod === 'manual'){<button mat-flat-button class="caps" (click)="showManualInstallInstructions()">App installieren</button>}
    }
  </mat-toolbar-row>
  }
</mat-toolbar>